import React from "react"
import DisabledLineItem from "./DisabledLineItem"


class RoomTypesDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.room_types && this.props.row.room_types.length > 0) {
      var roomTypes = []

      for (let step = 0; step < this.props.row.room_types.length; step++) {
        if (step < 4) {
            if (this.props.row.room_types[step].reservation_segment_status == "canceled"){
              roomTypes.push(<li style={{textDecoration: 'line-through'}} key={this.props.row.room_types[step].id}>{this.props.row.room_types[step].name}</li>)

            } else if (this.props.row.room_types[step].status == "disabled") {
            roomTypes.push(<DisabledLineItem key={this.props.row.room_types[step].id} data={this.props.row.room_types[step]} disabledRoomTypes={true} />)
          } else {
            roomTypes.push(<li key={this.props.row.room_types[step].id}>{this.props.row.room_types[step].name}</li>)
          };
        } else if (step === 4) {
          roomTypes.push(<li key='additional-room-types'><i>... {` ${I18n.t('more')}`}</i></li>)
        };
      };

      return (
        <ul className="RoomTypesDataType">{roomTypes}</ul>
      );
    } else {
      return null;
    }
  }

};

export default RoomTypesDataType
